const elTestOffer = document.querySelector('.test-offer');

if (elTestOffer) {
    const elsTestBtn = elTestOffer.querySelectorAll('.test-offer__btn');
    const elMoreBooksBtn = elTestOffer.querySelector('.test-offer__result-btn_more-books');
    const elRestartBooksBtn = elTestOffer.querySelector('.test-offer__result-btn-restart');
    const elSlider = elTestOffer.querySelector('.test-offer__slider');
    const answers = {};

    Array.from(elsTestBtn).forEach((item) => {
        item.addEventListener('click', (e) => {
            const evt = e.target;
            const elTestBox = evt.closest('.test-offer__box');
            const elTestBoxNext = elTestBox.nextElementSibling;
            const idQuestions = elTestBox.getAttribute('data-question');
            const idAnswers = item.getAttribute('data-answer');
            const elOtherTests = elTestOffer.querySelector('.test-offer__other-tests');

            function toggleClass(element) {
                element.classList.toggle('test-offer__box_active');
            }

            if (idAnswers && idQuestions) {
                answers[idQuestions] = idAnswers;
            }

            if (evt.classList.contains('test-offer__stop-href')) {
                if (elOtherTests) {
                    elOtherTests.classList.remove('test-offer__other-tests_active');
                }

                [elTestBox, elTestBox.previousElementSibling].forEach((element) => {
                    toggleClass(element);
                });
            } else if (elTestBoxNext) {
                toggleClass(elTestBox);

                if (elTestBoxNext.classList.contains('test-offer__box_stop')) {
                    if (evt.classList.contains('test-offer__btn_stop')) {
                        toggleClass(elTestBoxNext.nextElementSibling);
                    } else {
                        if (elOtherTests) {
                            elOtherTests.classList.add('test-offer__other-tests_active');
                            document.dispatchEvent(new CustomEvent('init.masonry.eksmo'));
                        }

                        toggleClass(elTestBoxNext);
                    }
                } else {
                    toggleClass(elTestBoxNext);
                }
            } else {
                elTestBox.classList.add('test-offer__box_inactive');

                elTestBox.insertAdjacentHTML('afterbegin',
                    `<div class="test-offer__loader loader loader_center"><svg class="loader__cont"><use xlink:href="#loader"></use></svg></div>`);

                fetch('./',
                    {
                        method: 'POST',
                        body: JSON.stringify({
                            ANSVERS: answers,
                        }),
                    })
                    .then((data) => {
                        if (data.ok) {
                            return Promise.resolve(data.text());
                        }

                        return Promise.reject(new Error(`Ошибка в test-offer.js: ${data.status}`));
                    })
                    .then((data) => {
                        document.location = `?r=${data}`;
                    })
                    .catch((err) => console.log(err));
            }
        });
    });

    if (elMoreBooksBtn) {
        elMoreBooksBtn.addEventListener('click', () => {
            elMoreBooksBtn.remove();
            elRestartBooksBtn.classList.add('test-offer__result-btn-restart-full-width');
            elSlider.classList.add('test-offer__slider_active');
        });
    }
}